module.exports = __webpack_public_path__ + "img/go9.8a0680ae.png";